<template>
  <div
    class="sitebuilder-element-container"
    element="VimeoVideoComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :id="id"
    :config-properties="JSON.stringify(internal_config)"
    v-on:click="focusElement($event)"
    @contextmenu.prevent="handler($event)"
    :style="style()"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
      :enable-native-drag="true"
    >
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <options-element-bar ref="optionsBar" :elem="this" name="ct-component-VimeoComponent">
             <img  src="static/images/icons/pin.svg"
              v-tooltip="{content:$t('ct-sticky'),  class: 'tooltip-custom'}"
              class="svg-icon normal-action hide-resource-on-mobile"
              @click="StickyElement"/>
      </options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>

      <div id="the-sticky-div" class="embed-responsive embed-responsive-16by9" v-if="this.preview">
        <div class="sticky-video-content">
          <div class="video">
            <iframe
              :width="internal_config.width"
              :height="internal_config.height"
              :src="getUrl()"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="embed-responsive-item"
              v-bind:style="{'border-radius': radius,border : border}"
            ></iframe>
          </div>
        </div>
      </div>
      <div class="preview-img" v-if="!this.preview">
        <img
          :src="getThumbnail()"
          :width="internal_config.width"
          :height="internal_config.height"
          v-bind:style="{'border-radius': radius,border : border}"
        />
        <font-awesome-icon :icon="['fas', 'play']" color="#19B7EA" class="font-awesome-icon sort-icon"/>
      </div>
      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>
<script>
import Model from "./Model";
import Resources from "./Resources.vue";
import OptionsElementBar from "../OptionsElementBar";

export default {
  name: "VimeoVideoComponent",
  components: {
    OptionsElementBar,
    Model,
    Resources
  },
  props: ["config", "height_start", "device", "id", "preview"],
  data() {
    return Model.data();
  },
  watch: {
    internal_config: {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },

  computed: {
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    }
  },
  methods: {
    debug() {
      console.log(this.internal_config);
    },

    animation() {
      return true;
    },
    getThumbnail() {
      const { src } = this.internal_config;
      let thumbnail;

      $.ajax({
        url: `https://vimeo.com/api/oembed.json?url=${src}`,
        async: false,
        success: ({ thumbnail_url }) => {
          thumbnail = thumbnail_url || '/static/images/vimeo.png';
        },
        error: err => {
          thumbnail = '/static/images/vimeo.png'
        }
      });

      return thumbnail;
    },
    getUrl() {

      let url = this.internal_config.src;
      let linkTemp = document.createElement('a');
      linkTemp.href = url;
      let search = linkTemp.search !== '';

      url =  url + ((search) ? '&' : '?');

      if (
        this.internal_config.checkBoxAutoPlay &&
        this.internal_config.checkBoxLoop
      ) {
        url = url + "autoplay=1&loop=1";
      } else {
        if (this.internal_config.checkBoxLoop) {
          url = url + "loop=1";
        } else {
          if (this.internal_config.checkBoxAutoPlay) {
            url = url + "autoplay=1";
          }
        }
      }
      return url;
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width + "px";
      this.internal_config.height = height + "px";

      this.$refs.resourcesData.setValuesData(this);
    },
    focusElement(e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    StickyElement: function () {
        this.$root.$emit('StickyElement', this);
    },

    //change order on html
    changeOrderPanel(elem, idx) {
      if (typeof this.$parent.changeOrderPanel !== "undefined") {
        this.$parent.changeOrderPanel(this, idx);
      } else {
        this.$parent.$parent.changeOrderPanel(this, idx);
      }
    },
    handler: function(e) {
      // this.$el.classList.add('animated', 'jello', 'infinite');
      this.$root.$emit("focusElement", this);
      this.$root.$emit("handlerElement", this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    style() {
      let style = `left:  ${this.internal_config.left};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
      return style;
    }
  },
    updated(){
      if(this.preview){
        if (this.internal_config.StickyVideo) {
          this.$root.$emit("applySticky", this,);
      }
    }
  },
  created() {
    let device, childs, id, config;
    ({ device, childs, id, config } = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== "undefined") {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    this.$refs.resourcesData.setValuesData(this);
    if (this.$props.preview) {
      this.$root.$emit("applyAnimation", this, "sitebuilder-element-container");
    }

    let objIds = [];
    $("[id]").each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on("setConfigElement", (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$forceUpdate();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.preview-img {
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
  }

  svg {
    position: absolute;
    font-size: 30px;
  }
}
// small
.stuckBR {
position: fixed;
z-index: 10;
bottom: 155px;
right: 10px;
transform: translateY(100%);
width: 260px;
height: 145px;
animation: fade-in-up .25s ease forwards;
}
.stuckTL {
position: fixed;
z-index: 10;
top: -65px;
left: 10px;
transform: translateY(100%);
width: 260px;
height: 145px;
animation: fade-in-up .25s ease forwards;
}
.stuckTR {
position: fixed;
z-index: 10;
top: -65px;
right: 10px;
transform: translateY(100%);
width: 260px;
height: 145px;
animation: fade-in-up .25s ease forwards;
}
.stuckBL {
position: fixed;
z-index: 10;
bottom: 155px;
left: 10px;
transform: translateY(100%);
width: 260px;
height: 145px;
animation: fade-in-up .25s ease forwards;
}
//medim
.stuckBRm {
position: fixed;
z-index: 10;
bottom: 227px;
right: 10px;
transform: translateY(100%);
width: 400px;
height: 227px;
animation: fade-in-up .25s ease forwards;
}
.stuckTLm {
position: fixed;
z-index: 10;
top: -140px;
left: 10px;
transform: translateY(100%);
width: 400px;
height: 227px;
animation: fade-in-up .25s ease forwards;
}
.stuckTRm {
position: fixed;
z-index: 10;
top: -140px;
right: 10px;
transform: translateY(100%);
width: 400px;
height: 227px;
animation: fade-in-up .25s ease forwards;
}
.stuckBLm {
position: fixed;
z-index: 10;
bottom: 237px;
left: 10px;
transform: translateY(100%);
width: 400px;
height: 227px;
animation: fade-in-up .25s ease forwards;
}

//lage
.stuckBRl {
position: fixed;
z-index: 10;
bottom: 283px;
right: 10px;
transform: translateY(100%);
width: 500px;
height: 283px;
animation: fade-in-up .25s ease forwards;
}
.stuckTLl {
position: fixed;
z-index: 10;
top: -140px;
left: 10px;
transform: translateY(100%);
width: 500px;
height: 283px;
animation: fade-in-up .25s ease forwards;
}
.stuckTRl {
position: fixed;
z-index: 10;
top: -170px;
right: 10px;
transform: translateY(100%);
width: 500px;
height: 283px;
animation: fade-in-up .25s ease forwards;
}
.stuckBLl {
position: fixed;
z-index: 10;
bottom: 293px;
left: 10px;
transform: translateY(100%);
width: 500px;
height: 283px;
animation: fade-in-up .25s ease forwards;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Vimeo/Vimeo.vue